import React, { Component } from "react";
import Slider from "react-slick";
import { Link } from "react-router-dom";
import { AffiliatesLogos } from "./LogoImports";
import "./index.css";

export default class Partners extends Component {
  render() {
   
    const settings = {
      dots: false,
      infinite: true,
      speed: 4000,
      slidesToShow: 6,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 0,
      cssEase: 'linear',
      arrows: false,
      pauseOnHover: true,
      responsive: [{
        breakpoint: 768,
        settings: {
          slidesToShow: 4
        }
      }, 
      {
        breakpoint: 520,
        settings: {
          slidesToShow: 3
        }
      }]
    };
    return (
      <React.Fragment>
        <div className="w-100 my-0 mx-auto pt-4 pb-2" style={{backgroundColor: this.props.bgColor || "hsl(0,0%,95%)"}}>
          <Slider {...settings}>
          {
            AffiliatesLogos && AffiliatesLogos.map(partner => (
              <div key={partner.name} className="logo__item slide">
                <Link to={partner.url}>
                  <img src={partner.logo} alt={partner.name} title={partner.name} />
                </Link>
              </div>
            ))
          }   
          </Slider>
        </div>
      </React.Fragment>
    );
  }
}


// WEBPACK FOOTER //
// ./src/Components/Partners/index.js